exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".create-edit-output-variant-dialog .ant-form-item-extra {\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.45);\n  margin-top: 4px;\n}\n", ""]);

// exports
